var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "print-footer" }, [
    _c("div", { staticClass: "footer-content" }, [
      _c("div", { staticClass: "footer-item" }, [
        _c("span", { staticClass: "label" }, [
          _vm._v(
            _vm._s(_vm.Lang.get("messages.print_date") || "تاريخ الطباعة") + ":"
          ),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.currentDateTime)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-item" }, [
        _c("span", { staticClass: "label" }, [
          _vm._v(
            _vm._s(_vm.Lang.get("messages.printed_by") || "طبع بواسطة") + ":"
          ),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.userName))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-item page-numbering" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.Lang.get("messages.page") || "صفحة") + " "
        ),
        _c("span", { staticClass: "pageNumber" }),
        _vm._v(" " + _vm._s(_vm.Lang.get("messages.of") || "من") + " "),
        _c("span", { staticClass: "totalPages" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer-bottom-line" }),
    _vm._v(" "),
    _c("div", { staticClass: "system-tag" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.systemName) +
          " - " +
          _vm._s(
            _vm.Lang.get("messages.automated_report") ||
              "تقرير تلقائي من النظام"
          ) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }